<template lang="pug">
#app(@click="setMenuOpen(false)" v-if="!engineeringWorks")
  .smart-bar(:class="{ focused: $route.fullPath === '/' }")
    .logo-container
      router-link.has-text-left(to="/")
        img.main-logo(
          alt="Cybersmart logo",
          :src="logopath"
        )
      h2(v-html="homeSubtitle").has-text-weight-bold.home-subtitle
    CybersmartMenu(v-if="showMenu")
  router-view(style="flex: 1")
  CybersmartFooter
  PrivacyCookieModal(v-if="this.$route.path !== '/privacy-policy'")
#app(v-else)
  section.engineering
    div.engineering__wrapper
      div.engineering__wrapper__block
        img(src="/img/engineering-works.svg")
        div.engineering__wrapper__message
          span Please be advised that technical maintenance is currently being conducted on the website. We apologize for any inconvenience and kindly ask you to try accessing the site later
  //CybersmartFooter
</template>

<script>
import CybersmartMenu from "@/components/Menu.vue";
import CybersmartFooter from "@/components/CybersmartFooter.vue";
import PrivacyCookieModal from "@/components/PrivacyCookieModal.vue";

import './brand'
import brand from "@/brand";

export default {
  components: { CybersmartFooter, CybersmartMenu, PrivacyCookieModal },
  async mounted() {
    document.title = brand.getBrand()[0].toUpperCase() +
    brand.getBrand().substring(1);

    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
    }

    const iconPaths = {
      "cybersmart": "/favicon_32.ico",
      "ftta"      : "/ftta_favicon.png",
      "gigalight" : "/gigalight_icon_32.png",
    };

    link.href = iconPaths[brand.getBrand()];
  },
  data() {
    return {
      engineeringWorks: Boolean(process.env.VUE_APP_UNDER_CONSTRUCTION)
    };
  },
  computed: {
    isMenuOpen() {
      return this.$store.getters.getMenuOpen;
    },
    logopath() {
      const logoPaths = {
        "cybersmart": "/img/CYBERSMART-Logo-Colour.svg",
        "ftta"      : "/img/ftta-vector-logo.svg",
        "gigalight" : "/img/gigalogo.png",
      };

      return logoPaths[brand.getBrand()];
    },
    homeSubtitle() {
      const subtitles = {
        "cybersmart": "GET CONNECTED WITH SOUTH AFRICA’S TOP RANKED ISP",
        "ftta"      : "FIBRE ME UP",
        "gigalight" : "Available in Upington",
    };

      return subtitles[brand.getBrand()];
    },
    showMenu() {
      const show = {
        "cybersmart": true,
        "ftta"      : false,
        "gigalight" : false,
      };

      return show[brand.getBrand()];
    }
  },
  methods: {
    setMenuOpen(val) {
      this.$store.commit("setMenuOpen", val);
    },
  },
};
</script>

<style lang="scss">
@import "~bulma/sass/utilities/initial-variables.sass";
@import "styles/variables";
@import "~bulma";

// standard black and grey
.title,
.subtitle,
.blog-article,
.box {
  color: $secondary-colour !important;
}

.card,
.box {
  border: none;
  border-radius: 0;
  -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $secondary-colour;
  display: flex;
  flex-direction: column;
  letter-spacing: 2px;
  font-weight: bold;

  &,
  html,
  body {
    min-width: 100%;
    min-height: 100vh;
  }
}

.smart-bar {
  display: flex;
  padding: 3rem 3rem 0 3rem;
  min-height: 0;
  transition: min-height 600ms;
  flex-direction: row;

  &.blur {
    filter: blur(3px);
  }

  .logo-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: auto;
    margin-right: -3rem;
    flex: 1;

    a {
      outline: none;
    }

    @include until($tablet) {
      margin-bottom: auto;
    }

    .home-subtitle {
      margin: 0;
      letter-spacing: 4px;
      opacity: 0;
      height: 0;
      transition: opacity 600ms, transform 30ms 700ms;
      transform: scale(0);
    }

    .main-logo {
      transition: transform 600ms, max-width 600ms;
      max-width: 300px;
      @include until($tablet) {
        width: calc(100% - 6rem);
      }
    }
  }

  &.focused {
    min-height: 50vh;

    .home-subtitle {
      margin: 2rem;
      opacity: 1;
      height: auto;
      transition: opacity 600ms, transform 30ms;
      transform: scale(1);
    }

    .main-logo {
      transform: translateX(calc(50vw - 50% - 3rem));
      /*align-self: center;*/
      max-width: 480px;
    }
  }
}

.has-text-red {
  color: #f40000;
}
.engineering {
  height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  &__wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
    border: 1px solid gray;
    //box-shadow: 0px 0px 5px 0px #01A5E8;
    padding: 65px;
    background: rgba(1, 1, 1, 0.01);
    &__message {
      width: 600px;
    }
    & img {
      width: 190px;
    }
  }
  @media(max-width: 750px) {
    .engineering__wrapper__message {
      width: 100%;
    }
  }
}
</style>
